import React from "react";
import SVG from "../../pages/SVG";
import { useDatePickerContext } from "./DatePickerContext";
import { Dayjs } from "dayjs";
import dayjs from "@dayjs";
import { useLocale } from "next-intl";

interface DateInputProps {
  onClick: () => void;
}

const DateInput: React.FC<DateInputProps> = ({ onClick }) => {
  const { selectedDate, error } = useDatePickerContext();
  const locale = useLocale();

  const formatDisplayDate = (date: Dayjs | null): string => {
    if (!date) {
      return "";
    }

    return dayjs(date)
      .locale(locale)
      .format(locale === "en" ? "ddd, MMM D" : "YYYY-MM-DD");
  };

  return (
    <button
      type="button"
      className={`custom-date-input desktop-calendar-input-container  flex w-full flex-row items-center justify-start gap-2 rounded-lg border-[1px] pl-4 md:w-full 2xl:border-2 ${
        error
          ? "border-red-500"
          : "border-sleap-gray-400 hover:border-sleap-gray-600 dark:border-input dark:hover:border-white"
      } bg-lightwhite text-sleap-gray-950 dark:bg-sleap-gray-950 dark:text-lightwhite`}
      onClick={onClick}
      aria-label="Select check-in and check-out dates"
      aria-invalid={error ? "true" : "false"}
    >
      <div className="relative h-6 w-6 overflow-hidden">
        <SVG
          src="/assets/v2/icons/calender-dark.svg"
          twClasses="block h-6 w-6 dark:hidden"
          alt=""
          width={24}
          height={24}
        />
        <SVG
          src="/assets/v2/icons/calendar-light.svg"
          twClasses="hidden h-6 w-6 dark:block"
          alt=""
          width={24}
          height={24}
        />
      </div>
      <div
        className="flex-1 text-base font-medium text-left"
        style={{ lineHeight: "24px" }}
      >
        {selectedDate?.[0] ? formatDisplayDate(selectedDate[0]) : "Check-in"}
        <span className="mx-1"> - </span>
        {selectedDate?.[1] ? formatDisplayDate(selectedDate[1]) : "Check-out"}
      </div>
    </button>
  );
};

export default DateInput;
